import createVueComponent from '../createVueComponent';

const Key = createVueComponent('KeyIcon', [
  ['circle', { cx: '7.5', cy: '15.5', r: '5.5', key: 'yqb3hr' }],
  ['path', { d: 'm21 2-9.6 9.6', key: '1j0ho8' }],
  ['path', { d: 'm15.5 7.5 3 3L22 7l-3-3', key: '1rn1fs' }],
]);

export default Key;
